// extracted by mini-css-extract-plugin
export default {"component__close":"dialog-layout_component__close_Bmv7U","component__content":"dialog-layout_component__content_F4KMK"};